// src/configs/apps/appcaup/appcaup.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import {
  AuditOutlined,
  CalendarOutlined,
  FundProjectionScreenOutlined,
  FileProtectOutlined,
  FunnelPlotOutlined,
  HomeOutlined,
  MailOutlined,
  ScheduleOutlined,
  SettingOutlined,
} from '@ant-design/icons';

// *******************************************************************************
// APP GLOBAL CONFIGURATION
// *******************************************************************************
const APP_CAUP = {
  ID: 'appcaup',
  NAME: 'ArrendaClick',
  THEME_COLOR: 'CUSTOM_CAUP_APP',
  THEME: 'light',
  FINTECH_SERVICES: false,
  DOMAINS: [
    // 'caup.empreendabrasil.com.br',
    'arrendaclick.biruel.dev',

    'appcaup-v1.web.app',
    'appcaup-v1-homologation.web.app',
  ],
  PRESET: {
    MULTI_SUBSCRIPTIONS: false,
    PROFILE: null,
    NATIVE_RESOURCES: [
      // 'moduleresources_caup_contracts',
      // 'moduleresources_caup_documentation',
      // 'moduleresources_caup_leads',
      // 'moduleresources_caup_calendar',
      // 'moduleresources_caup_visits',
      // 'moduleresources_caup_templates',
    ],
    SUGGESTED_RESOURCES: [],
    CAN_CHANGE_RESOURCES: true,
    SHOW_RESOURCES_FIRST_CONFIGURATION: false,
    SHOW_RESOURCES_SUBSCRIPTION: true,
    CONTRACT: null,
  },
  COPY_RIGHT: 'ArrendaClick',
  API_PORT_HOMOLOGATION: 9131,
  API_PORT_PRODUCTION: 9031,
  API_HOST_LOCALHOST: 'localhost',
  API_HOST_PRODUCTION: 'vps.jarvisly.com',
  API_INTEGRATED: false,
  TOKEN: import.meta.env.VITE_APPCAUP_TOKEN,
  TOKEN_EXP_MINUTES: 60,

  LOCALE: 'pt-PT',
  LANGUAGE: 'pt-PT',
  LANGUAGE_OPTIONS: ['pt-BR', 'pt-PT', 'en-US', 'es-ES'],

  LOGO_APP: '/apps/appcaup/logo-app.png',
  LOGO_APP_WHITE: '/apps/appcaup/logo-app-white.png',

  LOGO_APP_ICON: '/apps/appcaup/logo-app-icon.png',
  LOGO_APP_ICON_WHITE: '/apps/appcaup/logo-app-icon-white.png',

  LOGO: '/apps/appcaup/logo.png',
  LOGO_WHITE: '/apps/appcaup/logo-white.png',
  LOGO_LOGIN_SIDE: '/apps/appcaup/logo-app-side.png',

  PWA_NAME: { production: 'ArrendaClick', homologation: 'ArrendaClick Homologation' },
  PWA_SHORT_NAME: { production: 'ArrendaClick', homologation: 'ArrendaClick QA' },
  PWA_DESCRIPTION: 'ArrendaClick Alugue Online',
  TITLE: 'ArrendaClick',
  SLOGAN: '',
  SLOGAN2: '',
  SLOGAN_REGISTRATION: 'registration_slogan',
  SLOGAN_REGISTRATION2: '',
  APPLICATION_LAYER: 'adm',
  LOGIN_IDENTIFICATION: 'email',

  SELF_REGISTRATION: {
    homologation: false,
    production: false,
  },
  SELF_REGISTRATION_MOBILE_VALIDATION: ['pt-PT'],
  USER_INVITATION_MOBILE_VALIDATION: ['pt-PT'],

  GOOGLE_LOGIN: false,
  FACEBOOK_LOGIN: false,
  RESET_PASSWORD: true,
  NAVIGATION_TYPE: 'side',
  MODULES: ['contracts', 'documentation', 'leads', 'calendar', 'visits', 'templates'],
  SHOW_ALL_MENUS: false,
  BREADCRUMB_COLOR: '#FAFAFBFF',

  WELCOME_NEXT_STEPS: [
    'explore_the_system',
    'complete_your_profile',
    'create_your_first_subscription',
  ],

  MENU_APPLICATION: [
    {
      path: '/app/account',
      title: 'account',
      icon: SettingOutlined,
      moduleId: 'account',
      groupTitle: 'configuration',
    },
  ],

  MENU_NAVIGATION: [
    // ******************
    // HOME (standard standalone)
    // ******************
    {
      path: '/app/dashboard/overview',
      title: 'home',
      icon: HomeOutlined,
      moduleId: 'welcome',
      isGroupTitle: true,
    },

    // ******************
    // MAIN
    // ******************
    {
      path: '/app/main',
      title: 'main',
      icon: FileProtectOutlined,
      isGroupTitle: true,
      submenu: [
        {
          path: '/app/main/dashboard',
          title: 'dashboard',
          icon: FundProjectionScreenOutlined,
          moduleId: 'caupDashboard',
          requiredResources: ['moduleresources_caup_dashboard'],
        },
        {
          path: '/app/main/contracts',
          title: 'contracts',
          icon: FileProtectOutlined,
          moduleId: null,
          requiredResources: ['moduleresources_caup_contracts'],
        },
        {
          path: '/app/main/documentation',
          title: 'documentation',
          icon: AuditOutlined,
          moduleId: null,
          requiredResources: ['moduleresources_caup_documentation'],
        },
      ],
    },

    // ******************
    // CRM
    // ******************
    {
      path: '/app/crm',
      title: 'crm',
      icon: FunnelPlotOutlined,
      isGroupTitle: true,
      submenu: [
        {
          path: '/app/crm/leads',
          title: 'leads',
          icon: FunnelPlotOutlined,
          moduleId: null,
          requiredResources: ['moduleresources_caup_leads'],
        },
      ],
    },

    // ******************
    // AGENDA
    // ******************
    {
      path: '/app/agenda',
      title: 'agenda',
      icon: CalendarOutlined,
      isGroupTitle: true,
      submenu: [
        {
          path: '/app/agenda/calendar',
          title: 'calendar',
          icon: CalendarOutlined,
          moduleId: null,
          requiredResources: ['moduleresources_caup_calendar'],
        },
        {
          path: '/app/agenda/visits',
          title: 'visits',
          icon: ScheduleOutlined,
          moduleId: null,
          requiredResources: ['moduleresources_caup_visits'],
        },
      ],
    },

    // ******************
    // CONFIGURATION
    // ******************
    {
      path: '/app/configuration',
      title: 'configuration',
      icon: SettingOutlined,
      isGroupTitle: true,
      submenu: [
        {
          path: '/app/configuration/templates',
          title: 'templates',
          icon: MailOutlined,
          moduleId: null,
          requiredResources: ['moduleresources_caup_templates'],
        },
      ],
    },
  ],

  FIREBASE_CONFIG: JSON.parse(import.meta.env.VITE_APPCAUP_FIREBASE_CONFIG),
  MOCKUP: {
    AUTH: {
      SIGNIN: {
        email: 'me@biruel.dev',
        password: 'idadm123',
      },
      SIGNUP: {
        countryCode: 'BR',
        name: 'Suporte ArrendaClick',
        email: 'me@biruel.dev',
        emailCode: 1234,
        emailConfirmation: true,
        mobileCode: 1234,
        mobileConfirmation: true,
        password: 'idadm123',
      },
      RESET_PASSWORD: {
        email: 'me@biruel.dev',
        emailCode: 1234,
        password: 'idadm123',
      },
    },
  },
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default APP_CAUP;
